import Link from "@/components/MyLink";
import type { SetList } from "@/utils/types";
import { useRef } from "react";
import { MdClose, MdOutlinePrint } from "react-icons/md";

import formatSecondsAsMinutesSeconds from "@/utils/formatSecondsAsMinutesSeconds";

export default function SetListTitleBar({
  setList,
  totalDuration,
}: { setList: SetList; totalDuration: number }) {
  const toolbarRef = useRef(null);

  return (
    <div
      className="static flex p-1 pl-4 items-center bg-primary w-full"
      ref={toolbarRef}
    >
      <div className="flex-1">
        <span>{setList.title}</span>
        <span>{"  "}</span>
        <span className="text-sm">{setList.songIds.length} songs</span>
        {", "}
        <span className="text-sm">
          {formatSecondsAsMinutesSeconds(totalDuration)}
        </span>
      </div>
      <div className="text-right">
        <Link
          href={`/setlist/${setList.id}/${setList.title}/print`}
          className="btn btn-circle btn-ghost text-xl"
        >
          <MdOutlinePrint />
        </Link>
        <Link href="/" className="btn btn-circle btn-ghost text-xl">
          <MdClose />
        </Link>
      </div>
    </div>
  );
}
